

























































































import DescriptionCard from "@/components/thg/DescriptionCard.vue";
import KnownFormCard from "@/components/thg/KnownFormCard.vue";
import ThgProcessDescriptionCard from "@/components/thg/ThgProcessDescriptionCard.vue";
import ThgPriceOverview from "@/components/thg/ThgPriceOverview.vue";
import LoaderReport from "@/components/utility/LoaderReport.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
import i18n from "../../plugins/I18nPlugin";
import { thgQueryParams } from "@/lib/queryParams/thgQueryParams";

@Component({
  components: {
    LayoutReportWithBanner,
    LoaderReport,
    KnownFormCard,
    DescriptionCard,
    ThgProcessDescriptionCard,
    ThgPriceOverview
  }
})
export default class ThgHome extends Vue {
  screenName = ReportScreenEnum.thghome;

  get loading() {
    return ReportModule.loading;
  }

  get isWhiteLabelPartner(): boolean {
    return PartnerModule?.partner.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_QUOTE_AS_A_SERVICE;
  }

  get showTrustBanner(): boolean {
    return PartnerModule?.partner.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_MINT_FUTURE;
  }

  get headerImage() {
    if (PartnerModule?.partner?.settings?.reportSettings?.headerImageUrl) {
      return PartnerModule?.partner?.settings?.reportSettings?.headerImageUrl;
    } else if (PartnerModule?.partner?.settings?.headerImageUrl) {
      return PartnerModule?.partner?.settings?.headerImageUrl;
    } else {
      return "https://static.mmmint.ai/wirkaufendeinethg/header-image.png";
    }
  }

  get placeFillerImage() {
    if (PartnerModule?.partner.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_MINT_FUTURE) {
      return "https://static.mmmint.ai/wirkaufendeinethg/screen_mockups_thghome.png";
    }
    return "https://static.mmmint.ai/wirkaufendeinethg/screen_mockups_whitelabel_thghome.png";
  }

  get placeFillerImageLazy() {
    if (PartnerModule?.partner.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_MINT_FUTURE) {
      return "https://static.mmmint.ai/wirkaufendeinethg/screen_mockups_lazy_thghome.png";
    }
    return "https://static.mmmint.ai/wirkaufendeinethg/screen_mockups_whitelabel_lazy_thghome.png";
  }

  get logos() {
    return [
      "https://static.mmmint.ai/wirkaufendeinethg/trust/bvmw.svg",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/bvdp.svg",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/more.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/seedhouse.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/stadtwerke-os.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/smartcityhouse-os.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/ico.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/wfo.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/zukunftswerkstatt.png",
      "https://static.mmmint.ai/wirkaufendeinethg/trust/restemeier.png"
    ];
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get partnerColorDarkmode() {
    return this.$vuetify.theme.dark ? "white" : this.color;
  }

  get headlineText(): string {
    return String(
      i18n.t("report.thgHome.headline", {
        prefix: ThgCreateModule.bonusPrefix,
        bonus: ThgCreateModule.bonus
      })
    );
  }

  get cooperationText(): string {
    return String(i18n.tc("report.thgHome.cooperation"));
  }

  get knownFromText(): string {
    return String(i18n.tc("report.thgHome.knownFrom"));
  }

  get title(): string {
    return String(i18n.tc("report.thgHome.title"));
  }

  get subHeadlineText(): string {
    return ThgCreateModule.subHeadlineText;
  }

  get subTitle(): string {
    if (!this.isAuthenticated) {
      return String(
        i18n.t("report.thgHome.subTitle", {
          prefix: ThgCreateModule.bonusPrefix,
          bonus: ThgCreateModule.bonus
        })
      );
    } else {
      return String(i18n.tc("report.thgHome.subTitleAlt"));
    }
  }

  get subTitle2(): string {
    if (!this.isAuthenticated) {
      return String(i18n.t("report.thgHome.subTitle2"));
    } else {
      return String(i18n.tc("report.thgHome.subTitle2"));
    }
  }

  get submitButtonText(): string {
    if (!this.isAuthenticated) {
      return String(i18n.tc("report.thgHome.btnText"));
    } else {
      return String(i18n.tc("report.thgHome.btnTextAlt"));
    }
  }

  get isAuthenticated(): boolean {
    return UserModule.isAuthenticated;
  }

  goToLogin() {
    this.$router.push({ path: "/login" });
  }

  start() {
    if (ReportModule.nextScreen) {
      const next = ReportModule.nextScreen;
      ReportModule.setStep(next);
      this.$router.push({ path: `/${next}` });
    }
    this.$gtag.event("begin_checkout", {
      currency: "EUR",
      value: ThgCreateModule.bonus ?? "0",
      coupon: ThgCreateModule.code || ThgCreateModule.campaign || "",
      items: [
        {
          item_id: "0",
          item_name: "THG"
        }
      ]
    });
  }

  async mounted() {
    try {
      // if some data is given in the query the report is prefilled.
      this.prefillDataFromQuery();
    } catch (error) {
      Vue.$log.error(error);
    }

    ReportModule.setStep(this.screenName);
  }

  prefillDataFromQuery() {
    thgQueryParams.forEach(param => {
      const value = this.$route.query[param.key];

      if (value) {
        param.onFound((value as string) || "");
        this.$log.info(`${param.key} set in store`);
      }
    });
  }
}
